import { DashLanguages } from "dash-common";

// Each language is named in itself, so it stays recognisable whatever the UI language is.
export const PORTAL_LANGUAGE_NAMES: Record<DashLanguages, string> = {
  [DashLanguages.EN]: "English",
  [DashLanguages.ES]: "Español",
  [DashLanguages.PT]: "Português",
};
